import { newE2EPage } from "@stencil/core/testing";

describe("uic-footer-menu", () => {
    it("should show and hide with clicks", async () => {
        const page = await newE2EPage();
        await page.setContent(`
            <uic-footer-menu>
                <uic-button variant="footer" slot="button">
                    Button
                </uic-button>
                <uic-button variant="footer-primary">
                    Item
                </uic-button>
            </uic-footer-menu>`);

        const uicShow = await page.spyOnEvent("uicShow");
        const uicHide = await page.spyOnEvent("uicHide");

        const menu = await page.find("uic-footer-menu");
        expect(menu).toHaveClass("hydrated");

        const button = await page.find("uic-button[slot='button']");
        await button.click();

        await page.waitForChanges();

        expect(uicShow).toHaveReceivedEvent();

        await button.click();
        await page.waitForChanges();

        expect(uicHide).toHaveReceivedEvent();
    });
});
